import { render, staticRenderFns } from "./PublicationGoals.vue?vue&type=template&id=5d017126&scoped=true"
import script from "./PublicationGoals.vue?vue&type=script&lang=js"
export * from "./PublicationGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d017126",
  null
  
)

export default component.exports